import React, { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Progress } from 'web-library';
import { parseLocationSearch } from '../../../utils/StringUtils';
import RouteKey from '../../../routes/key';
import { usePostVerifyUniqueLink } from '../../../api-refactored/unique-link/usePostVerifyUniqueLink';

const { exam, error: errorRoute, uniqueLink } = RouteKey.child;
const {
  examRegistrations,
  registerExam,
  coordinatorExamRegistrations,
  coordinatorRegisterExam,
  nonNationalExaminations,
} = RouteKey.exam.child;

const { generic } = RouteKey.error.child;
const { invalid } = RouteKey['unique-link'].child;

const { appeal } = RouteKey.child;
const { importantNotes, applications, applicationsCoordinator } = RouteKey.appeal.child;

const candidateInstructionPage = `/${exam}/${examRegistrations.route}/${registerExam.route}`;
const candidateNonNationalInstructionPage = `/${exam}/${examRegistrations.route}/${nonNationalExaminations.route}`;
const coordinatorInstructionPage = `/${exam}/${coordinatorExamRegistrations.route}/${coordinatorRegisterExam.route}`;

const VerifyUniqueLink = () => {
  const location = useLocation();
  const history = useHistory();

  const { token = '', applicationType = '' } = parseLocationSearch(location.search);

  const getInstructionPageURL = (level: string) => {
    let instructionPageURL = '';
    switch (level) {
      case 'GCE':
        instructionPageURL = `${candidateInstructionPage}/GCE?token=${token}`;
        break;

      case 'PSLE':
        instructionPageURL = `${candidateInstructionPage}/PSLE?token=${token}`;
        break;

      case 'AEIS':
        instructionPageURL = `${candidateNonNationalInstructionPage}/aeis?token=${token}`;
        break;

      case 'S_AEIS':
        instructionPageURL = `${candidateNonNationalInstructionPage}/s-aeis?token=${token}`;
        break;

      case 'SPE':
        instructionPageURL = `${candidateNonNationalInstructionPage}/spe?token=${token}`;
        break;

      case 'SPERS_SEC':
        instructionPageURL = `${candidateNonNationalInstructionPage}/spers-sec?token=${token}`;
        break;

      default:
        break;
    }

    return instructionPageURL;
  };

  const { mutate } = usePostVerifyUniqueLink({
    onSuccess: (data) => {
      if (applicationType === 'APPEAL') {
        switch (data.userType) {
          case 'CANDIDATES':
            history.push(`/${appeal}/${applications.route}/${importantNotes.route}?token=${token}`);
            break;

          case 'COORDINATORS':
            history.push(
              `/${appeal}/${applicationsCoordinator.route}/${importantNotes.route}?token=${token}`
            );
            break;
          default:
            history.push(`/${errorRoute}`);
        }
      } else if (applicationType === 'EXAM') {
        switch (data.userType) {
          case 'CANDIDATES':
            history.push(getInstructionPageURL(data.examLevel), {
              waiveLateFee: data.isWaiveLateFee,
            });
            break;

          case 'COORDINATORS':
            history.push(`${coordinatorInstructionPage}/${data.examLevel}?token=${token}`, {
              waiveLateFee: data.isWaiveLateFee,
            });
            break;
          default:
            history.push(`/${errorRoute}`);
        }
      }
    },
    onError: (error) => {
      const errorCode = error?.response?.data?.code;

      if (
        errorCode === '1003' ||
        errorCode === '1006' ||
        errorCode === '1019' ||
        errorCode === '1014'
      ) {
        history.push(`/${uniqueLink}/${invalid}`);
      } else if (errorCode === '1203') {
        history.push(`/${errorRoute}/${generic}`);
      }
    },
  });

  useEffect(() => {
    if (!token || !applicationType) {
      history.push(`/${errorRoute}`);
    } else {
      mutate({ token, applicationType });
    }
  }, [history, token, applicationType, mutate]);

  return (
    <>
      <Progress color="secondary" />
    </>
  );
};

export default VerifyUniqueLink;
